import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';

import { validateEmail } from '../Shared/validations';

import Button from '../../components/Button';
import TwoGroup from '../../components/TwoGroup';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import { isPortrait } from '../../utils/size';

import { copyFor, capitalization } from '../../copy/copy';

const Thanks = styled.div`
    font-weight: bold;
    margin-top: 10px;
`;

const SubscribeFormContainer = styled.form`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    > div {
        display: inline-block;
        width: 100%;
        height: 100%;
        flex: auto;
        margin-right: 0 !important;

        > div {
            width: 100%;
            display: inline-block;
            flex: auto;

            @media (max-width: 30em) {
                width: 100%;
            }

            div {
                margin-right: 0 !important;
            }

            input {
                width: 100%;

                @media (max-width: 30em) {
                    height: 46px;
                    margin-bottom: 12px;
                }
            }
        }

        p {
            display: flex;
            flex: 1;
            font-size: ${props => (isPortrait() ? 16 : props.numActions > 1 ? 12 : 15)}px;
            margin: 0;
        }

        button {
            height: 45px;
            left: 0;
            bottom: 0;
            width: 100%;
            padding: 0 1em;
            text-indent: ${props => (props.isEmailSubmitting ? '-99999px' : '0')};

            @media (max-width: 30em) {
                height: 65px;
                width: 100%;
            }

            &:focus {
                outline: none;
            }

            &:hover {
                ${props =>
                    props.disabled
                        ? `
                            color: unset !important;
                            background-color: unset !important;
                            border: solid 1px #e5e3e3 !important;
                            span {
                                color: #cbc8c8
                            }`
                        : ``};
            }

            + div {
                position: absolute;
                top: ${() => (isPortrait() ? 145 : 160)}px;
                right: ${props =>
                    props.volunteerForm
                        ? isPortrait()
                            ? 42
                            : props.numActions === 1
                            ? 48
                            : 40
                        : 14}%;

                margin-right: -11px;
                width: 22px !important;
                height: 22px !important;
                display: ${props => (props.isEmailSubmitting ? 'block' : 'none')};

                @media (max-width: 30em) {
                    top: auto;
                    bottom: 22px;
                    right: auto;
                    left: calc(50% - 11px);
                    margin-left: 0 !important;
                }
            }
        }
    }
`;

const ChangeLocationLink = styled.p`
    font-size: 10px !important;
    color: #008eff;
    margin-top: 5px !important;
    cursor: pointer;
`;

const VolunteerSubscribeForm = props => (
    <SubscribeFormContainer
        numActions={props.numActions}
        volunteerForm={props.volunteerForm}
        onSubmit={props.handleSubmit}
        autocomplete="on"
        isEmailSubmitting={props.isEmailSubmitting}
        disabled={props.invalid}
    >
        {props.isEmailSubmitted ? (
            <Thanks>{copyFor('subscribe', 'thanks', 'volunteer')}</Thanks>
        ) : (
            <div>
                {props.volunteerForm &&
                    (props.numActions > 1 ? (
                        <div>
                            <p>{copyFor('subscribe', 'signUp', 'volunteer')}</p>
                            <ChangeLocationLink
                                onClick={() =>
                                    props.onShowLocationChangePopup(
                                        true,
                                        props.actionIdentifier
                                    )
                                }
                            >
                                {copyFor('subscribe', 'search', 'volunteer')}
                            </ChangeLocationLink>
                        </div>
                    ) : (
                        <p>{copyFor('subscribe', 'noneAvailable', 'volunteer')}</p>
                    ))}
                <TwoGroup>
                    <Field
                        name="email"
                        component={InputGroup}
                        type="email"
                        label=""
                        placeholder={copyFor('placeholders', 'emailAddress', 'volunteer')}
                    />
                    <Button
                        primary={true}
                        label={copyFor(
                            'buttons',
                            'submit',
                            'volunteer',
                            capitalization.all
                        )}
                        type="submit"
                        className="submitButton"
                        disabled={props.invalid}
                    />
                    <LoadingSpinner />
                </TwoGroup>
            </div>
        )}
    </SubscribeFormContainer>
);

VolunteerSubscribeForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    isEmailSubmitting: PropTypes.bool,
    isEmailSubmitted: PropTypes.bool,
    invalid: PropTypes.bool.isRequired,
    numActions: PropTypes.number,
    volunteerForm: PropTypes.bool,
    onShowLocationChangePopup: PropTypes.func,
    actionIdentifier: PropTypes.string
};

export default compose(
    connect(state => ({
        initialValues: {
            email: state.cachedFormData.email || ''
        }
    })),
    reduxForm({
        form: 'subscribeDetailsForm',
        validateEmail,
        destroyOnUnmount: false
    })
)(VolunteerSubscribeForm);
